import React, { useState } from "react";
import Arrow from "../../../../../../images/ArrowRight.svg";
import Input from "../../../../../../stories/Input/Input";
import { Button } from "../../../../../../stories/Button/Button";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
  GridColumnHeaderParams,
} from "@mui/x-data-grid-pro";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../../utils/types";
import { CheckBox } from "@mui/icons-material";
import Info from "../../../../../../images/Info.svg";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { SubsidiaryPriority } from "../../../../../../utils/Enum.types";
import Modal from "react-modal";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import View from "../../../masters/subsidary/view/Index";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import useLabels from "../../../../../../customHooks/useLabels";
const Data = [
  {
    no: "CC0",
    request_from_subsidiary: "Demo Company",
    desc_sent_on_rfq: "CCTV Camera",
    priority: "Low",
  },
  {
    no: "CC01",
    request_from_subsidiary: "Eduate Company",
    desc_sent_on_rfq: "CCTV Camera",
    priority: "High",
  },
  {
    no: "CC02",
    request_from_subsidiary: "Eduate Company",
    desc_sent_on_rfq: "CCTV Camera",
    priority: "Mid",
  },
];

interface Props {
  setFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export const enum PageFor {
  ADD = "Add",
  View = "View",
}
const Subsidiary = ({ setFlag, pageType }: Props) => {
  const { Purchase } = useAssetTableJson();
  const [viewSubsidiary, setViewSubsidiary] = useState(false);

  const dynamicHeaders: TableHeaderProps[] = Purchase.Quotation.Subsidiary.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderHeader:
        header.field === "id"
          ? (params: GridColumnHeaderParams) => (
              <>
                <CheckBox /> <span>{params.colDef.headerName}</span>
              </>
            )
          : undefined,

      renderCell: (params) => {
        if (header.field === "id") {
          return (
            <>
              <CheckBox />
            </>
          );
        }
        if (header.field === "request_from_subsidiary") {
          return (
            <div className="amr__subsidiary--info">
              {params.row.request_from_subsidiary} <img src={Info} alt="Info" />
            </div>
          );
        }
        if (header.field === "priority") {
          return (
            <span
              className={
                params.row.priority === SubsidiaryPriority.HIGH
                  ? "font-red"
                  : params.row.priority === SubsidiaryPriority.LOW
                  ? "font-green"
                  : ""
              }
            >
              {params.row.priority}
            </span>
          );
        }
        return params.value; // Default behavior for other cells
      },
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        material_request_no: data.no,
        request_from_subsidiary: data.request_from_subsidiary,
        desc_sent_on_rfq: data.desc_sent_on_rfq,
        requested_qty: 0,
        accepted_qty: 0,
        priority: data.priority,
        need_before: "10-11-2024",
        rfq_date: "10-11-2024",
        rfq_sent_for: "3 Suppliers",
        remark: "Please Send good Product",
      };
    }) || [];
    const {subsidiaryLabel}=useLabels();
  return (
    <>
      <div className="amr__subsidiary">
        {pageType === PageFor.View ? (
          <button
            className="amr__subsidiary--back"
            onClick={() => setFlag(false)}
          >
            <img src={Arrow} alt="" />
            Back
          </button>
        ) : (
          <>
            <div className="amr__title">
              <Title variant="subtitle1">Select {subsidiaryLabel}</Title>
              <img src={Close} alt="" onClick={() => setFlag(false)} />
            </div>
          </>
        )}

        <div className="amr__subsidiary--header">
          <b>CCTV Camera </b>
          <span>CC00123</span>
        </div>
        <div className="row g-0">
          <div className="col-3">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col"></div>
          <div className="col-3 flex-end">
            <div className="overall-total-count">
              Total {subsidiaryLabel} : <b>{Data.length}</b>
            </div>
          </div>
        </div>
        <div className="amr__subsidiary--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            hideFooter
            onCellClick={(params) => {
              if (params.field === "request_from_subsidiary") {
                setViewSubsidiary(!viewSubsidiary);
              }
            }}
          />
        </div>
        <Button mode="apply" />
        <Button mode="clear" />
        <Button mode="cancel" onClick={() => setFlag(false)} />
      </div>
      <Modal
        isOpen={viewSubsidiary}
        style={ViewModalStyles}
        ariaHideApp={false}
      >
        <View setModalFlag={setViewSubsidiary} />
      </Modal>
    </>
  );
};

export default Subsidiary;
